import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { GuiaListMem } from "app/features/general/operativa/items/guias/listados/guias/list/listmem";

type Entity = models.CargaZE;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un CargaZE
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un CargaZE
*/
export class GuiasPreviasCarga extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    idCarga = createSelectorRx(this.value, value => value.IdRegistro);
    idVehiculo = createSelectorRx(this.value, value => value.IdVehiculoZE);
    guias = createSelectorRx(this.idCarga, this.idVehiculo, (idCarga, idVehiculo) => observeResource(resources.CargaZE.GuiasEnVehiculoDistintaCarga, idVehiculo, idCarga));

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const guias = this.guias(this.props);

        return (
            <kea.Modal
                buttons={[]}
                onClose={this.onCerrar}
                title="Guias en el vehículo de distintas cargas de zona extendida"
            >
                <GuiaListMem value={guias} />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasze/edit/guiasanterioresmodal.tsx